/* eslint-disable jsx-a11y/no-access-key */
import React from 'react';
import ShareLink from 'components/ShareLink';
import moment from 'moment';
import styles from './index.module.scss';

interface IHead {
    title?: string;
    setCopied: (bool: boolean) => void;
    author?: string;
    dataSource?: string;
    imageSource?: string;
    date?: string;
    isArticle?: boolean;
    mainCategory?: string;
    subCategory?: string;
    isPreview:boolean;
}

const Head: React.FC<IHead> = ({
    title, setCopied, author, dataSource, imageSource, date, isArticle, mainCategory, subCategory, isPreview
}): JSX.Element => {
    const onCopy = () => {
        setCopied(true);
    };
    return (
        <div className={styles.head}>
            <div className={styles.container}>
                <a title="內容區" id="content" href="#content" accessKey="C" className={styles.anchor}>:::</a>
                {isArticle && <div className={styles.breadcrumb}>{`${mainCategory} > ${subCategory}`}</div>}
                <div className={styles.titleLinksContainer}>
                    <h2 className={styles.title}>{title}</h2>
                    <ShareLink setCopied={onCopy} isPreview={isPreview} />
                </div>
                {isArticle && (
                    <div className={styles.informationContainer}>
                        { author && (
                            <div>
                                作者：
                                {author}
                            </div>
                        )}
                        { dataSource && (
                            <div>
                                資料來源：
                                {dataSource}
                            </div>
                        )}
                        {
                            imageSource && (
                                <div>
                                    圖片來源：
                                    {imageSource}
                                </div>
                            )
                        }
                        <div>
                            日期：
                            {moment(date).format('YYYY-MM-DD')}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

Head.defaultProps = {
    title: '',
    author: '',
    dataSource: '',
    imageSource: '',
    date: '',
    isArticle: false,
    mainCategory: '',
    subCategory: ''
};

export default Head;
